<template>
  <div class="class-analysis">
    <!-- <div class="scroll-content"> -->
    <div class="analysis-filter">
      <div class="left">
        <el-form ref="filterForm" slot="filter-form" :model="filterForm"  inline>
          <el-form-item prop="major">
            <el-select placeholder="请选择专业" size="small" v-model="filterForm.major" @change="handleMajorChange">
              <el-option v-for="item in filterDataList.major" :key="item.id" :label="item.dictionaryName" :value="item.id" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="class">
            <el-select v-model="filterForm.class" placeholder="请选择班级" size="small" @change="handleClassChange" filterable>
              <el-option v-for="item in filterDataList.class" :key="item.id" :label="item.levelNum + item.name" :value="item.id" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="chapter">
            <el-select v-model="filterForm.chapter" placeholder="请选择章节" size="small" @change="handleChapterChange">
              <el-option v-for="item in filterDataList.chapter" :key="item.id" :label="item.levelPath + ' ' + item.name" :value="item.id" ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="right">
        <span>此数据为班级数据，每日凌晨更新～</span>
      </div>
    </div>
    <div class="scroll-content"> 
      <div class="title-card">
        <div class="card-header">
          <div class="bar"></div>
          <div class="title">学生排行榜</div>
        </div>
        <div class="card-content student-rank-content">
          <div v-if="!filterForm.class || !filterForm.chapter" class="card-empty-status">
            <img class="img-card-empty-status" src="../../assets/images/empty.png" draggable="false" alt="暂无数据～" />
            <div class="text">暂无数据～</div>
          </div>
          <div v-else class="rank-content">
            <div v-for="(rank, key) in studentRankData" :key="key" class="rank-panel" :class="rank.class" >
              <div class="title">
                <div class="text">
                  {{rank.title}}
                  <el-tooltip :popper-class="rank.dataKey" effect="light" :content="rank.tooltip" placement="top-start">
                    <i class="icon el-icon-info"></i>
                  </el-tooltip>
                </div>
                <img v-if="key === 'study'" class="img-medal-study" src="../../assets/images/medal-study.png" draggable="false" alt="study" />
                <img v-else-if="key === 'theory'" class="img-medal-theory" src="../../assets/images/medal-theory.png" draggable="false" alt="theory" />
                <img v-else-if="key === 'illness'" class="img-medal-illness" src="../../assets/images/medal-illness.png" draggable="false" alt="illness" />
              </div>
              <div class="ranks" v-if="rank.data && rank.data.length > 0">
                <div class="rank first">
                  <div class="left">
                    <img class="img-rank-trophy" src="../../assets/images/trophy-first.png" draggable="false" alt="first" />
                    <span class="name">{{rank.data[0] && rank.data[0].userName}}</span>
                  </div>
                  <div class="progress">{{rank.data[0][rank.dataKey]}}%</div>
                </div>
                <div class="rank second"  v-if="rank.data.length >= 2">
                  <div class="left">
                    <img class="img-rank-trophy" src="../../assets/images/trophy-second.png" draggable="false" alt="second" />
                    <span class="name">{{rank.data[1] && rank.data[1].userName}}</span>
                  </div>
                  <div class="progress">{{rank.data[1][rank.dataKey]}}%</div>
                </div>
                <div class="rank third" v-if="rank.data.length >= 3">
                  <div class="left">
                    <img class="img-rank-trophy" src="../../assets/images/trophy-third.png" draggable="false" alt="third" />
                    <span class="name">{{rank.data[2] && rank.data[2].userName}}</span>
                  </div>
                  <div class="progress">{{rank.data[2][rank.dataKey]}}%</div>
                </div>
                <div class="omit" v-if="rank.data.length >= 4 && rank.data[3].sortNum > 4">......</div>
                <div class="rank last" v-if="rank.data.length >= 4">
                  <div class="left">
                    <span class="rank-number">{{rank.data[3].sortNum}}</span>
                    <span class="name">{{rank.data[3].userName}}</span>
                  </div>
                  <div class="progress">{{rank.data[3][rank.dataKey]}}%</div>
                </div>
                <template v-if="rank.data.length < 4">
                  <div v-for="i in (4 - rank.data.length)" :key="i" class="rank-placeholder"></div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="title-card">
        <div class="card-header">
          <div class="bar"></div>
          <div class="title">小节学习详情</div>
        </div>
        <div class="card-content section-study-detail-content">
          <div v-if="!this.filterForm.class || !this.filterForm.chapter ||
            (isFirstRender && sectionStudyTableData.list.length <= 0)" class="card-empty-status"
          >
            <img class="img-card-empty-status" src="../../assets/images/empty.png" draggable="false" alt="暂无数据～" />
            <div class="text">暂无数据～</div>
          </div>
          <template v-else>
            <div class="search-panel">
              <el-form ref="sectionStudySearchForm" :model="sectionStudyTableData" inline>
                <el-form-item  prop="class">
                  <el-input v-model="sectionStudyTableData.searchFrom.section" placeholder="搜索小节序号或名称" clearable size="medium">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <div class="search-btn" @click="sectionStudySearch()">搜索</div>
                </el-form-item>
              </el-form>
            </div>
            <div class="section-study-table">
              <el-table ref="sectionStudyTable" :height="sectionStudyTableHeight" :data="sectionStudyTableData.list"
                @sort-change="handleSortChange"
                border :header-cell-style="{background:'#EBF3FF', color:'#4F6389'}"
              >
                <el-table-column prop="directoryLevelPath" label="小节名称" sortable='custom' min-width="310px">
                  <template v-slot="{ row }">
                    <div class="table-section-name">
                      <div class="name">{{row.directoryLevelPath +'&nbsp;'+ row.directoryName}}</div>
                      <div class="tag necessary" v-if="row.task === 1">必</div>
                      <div class="tag choice" v-else-if="row.task === 0">选</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="视频题（已学完人数）" align="center" min-width="180px">
                  <template v-slot="{ row }">
                    <div v-if="!row.videoStatus">/</div>
                    <div v-else class="table-charts-panel">
                      <div class="table-pie-chart">
                        <div class="pie-chart"
                          :style="{
                            '--progress': `${row.totalNum !== 0 ? (row.videoTotalNum / row.totalNum *100).toFixed(2) : 0}%`
                          }"
                        ></div>
                      </div>
                      <div class="table-pie-data">{{row.videoTotalNum}}人</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="理论题（已学完人数/掌握情况）" align="center" min-width="300px">
                  <template v-slot="{ row }">
                    <div v-if="!row.questionStatus">/</div>
                    <div v-else class="table-charts-panel">
                      <div class="table-pie-chart">
                        <div class="pie-chart"
                          :style="{
                            '--progress': `${row.totalNum !== 0 ? (row.questionTotalNum / row.totalNum *100).toFixed(2) : 0}%`
                          }"
                        ></div>
                      </div>
                      <div class="table-pie-data">{{row.questionTotalNum}}人</div>
                      <div class="table-bar-chart">
                        <div class="bar-chart" :style="{ width: `${row.questionRate}%` }"></div>
                      </div>
                      <div class="table-bar-data">{{row.questionRate}}%</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="病例题（已学完人数/掌握情况）" align="center" min-width="480px">
                  <template v-slot="{ row }">
                    <div v-if="!row.studyStatus">/</div>
                    <div v-else class="table-charts-panel">
                      <div class="table-pie-chart">
                        <div class="pie-chart"
                          :style="{
                            '--progress': `${row.totalNum !== 0 ? (row.studyTotalNum / row.totalNum *100).toFixed(2) : 0}%`
                          }"
                        ></div>
                      </div>
                      <div class="table-pie-data">{{row.studyTotalNum}}人</div>
                      <div class="table-bar-chart">
                        <div class="bar-chart" :style="{ width: `${row.studyFindRate}%` }"></div>
                      </div>
                      <div class="table-bar-data">{{row.studyFindRate}}%</div>
                      <div class="table-bar-chart">
                        <div class="bar-chart" :style="{ width: `${row.studyRate}%` }"></div>
                      </div>
                      <div class="table-bar-data">{{row.studyRate}}%</div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="pagination-panel">
                <el-pagination
                  :current-page="sectionStudyTableData.pagination.currentPage"
                  :page-size="sectionStudyTableData.pagination.pageSize"
                  :page-sizes="[5, 10, 20, 30, 40, 50]"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="sectionStudyTableData.pagination.total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  background
                ></el-pagination>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="title-card">
        <div class="card-header">
          <div class="bar"></div>
          <div class="title">本章理论错题榜</div>
        </div>
        <div class="card-content chapter-theory-wrong-content">
          <div class="nav-bars">
            <div v-for="(item, index) in theoryWrongNavOptions" :key="index" @click="theoryWrongNavClick(item)"
              class="nav" :class="theoryWrongNavValue === item.type ? 'active-nav': ''">
              {{ item.title }}
            </div>
          </div>
          <div v-if="!this.filterForm.class || !this.filterForm.chapter || theoryWrongTableData.length <= 0" class="card-empty-status">
            <img class="img-card-empty-status" src="../../assets/images/empty.png" draggable="false" alt="暂无数据～" />
            <div class="text">暂无数据～</div>
          </div>
          <div v-else class="theory-wrong-table">
            <el-table ref="theoryWrongTable" :data="theoryWrongTableData"
              border :header-cell-style="{background:'#EBF3FF', color:'#4F6389'}"
            >
              <el-table-column prop="title" label="题干" min-width="390px"></el-table-column>
              <el-table-column prop="keyword" label="关键词" min-width="240px"></el-table-column>
              <el-table-column prop="answerNum" label="作答人数" align="center" min-width="90px">
                <template v-slot="{ row }">
                  {{row.answerNum}}人
                </template>
              </el-table-column>
              <el-table-column label="错误率" min-width="250px" align="center">
                <template v-slot="{ row }">
                  <div class="table-charts-panel">
                    <div class="table-bar-chart">
                      <div class="bar-chart" :style="{ width: `${row.errorRate}%` }"></div>
                    </div>
                    <div class="table-bar-data">{{row.errorRate}}%</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="错题权重" align="center" min-width="120px">
                <template slot="header">
                  <div class="header-wrong-weight">
                    错题权重
                    <el-tooltip :popper-class="'sectionRate'" effect="light" content="错题权重=作答人数 * 错误率" placement="top">
                      <img class="img-view-details" src="../../assets/images/view-details.png" draggable="false"/>
                    </el-tooltip>
                  </div>
                </template>
                <template v-slot="{ row }">
                  <div class="table-charts-panel">
                    {{row.weight}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" min-width="100px">
                <template v-slot="{ row }">
                  <div class="table-view-detail">
                    <div class="text" @click="theoryWrongViewDetail(row)">查看详情<i class="el-icon-arrow-right el-icon--right"></i></div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <div class="title-card">
        <div class="card-header">
          <div class="bar"></div>
          <div class="title">本章病例错题榜</div>
        </div>
        <div class="card-content chapter-illness-wrong-content">
          <div v-if="!this.filterForm.class || !this.filterForm.chapter || illnessWrongTableData.length <= 0" class="card-empty-status">
            <img class="img-card-empty-status" src="../../assets/images/empty.png" draggable="false" alt="暂无数据～" />
            <div class="text">暂无数据～</div>
          </div>
          <div v-else class="illness-wrong-table">
            <el-table ref="illnessWrongTable" :data="illnessWrongTableData"
              border :header-cell-style="{background:'#EBF3FF', color:'#4F6389'}"
            >
              <el-table-column prop="modality" label="检查类型" width="90px"></el-table-column>
              <el-table-column prop="title" label="病例标题" min-width="260px"></el-table-column>
              <el-table-column prop="keyword" label="关键词" min-width="200px"></el-table-column>
              <el-table-column prop="answerNum" label="作答人数" align="center" min-width="90px">
                <template v-slot="{ row }">
                  {{row.answerNum}} 人
                </template>
              </el-table-column>
              <el-table-column label="诊断错误率" min-width="250px" align="center">
                <template v-slot="{ row }">
                  <div class="table-charts-panel">
                    <div class="table-bar-chart">
                      <div class="bar-chart" :style="{width: `${row.errorRate}%` }"></div>
                    </div>
                    <div class="table-bar-data">{{row.errorRate}}%</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="错题权重" align="center" min-width="120px">
                <template slot="header">
                  <div class="header-wrong-weight">
                    错题权重
                    <el-tooltip :popper-class="'sectionRate'" effect="light" content="错题权重=作答人数 * 错误率" placement="top">
                      <img class="img-view-details" src="../../assets/images/view-details.png" draggable="false"/>
                    </el-tooltip>
                  </div>
                </template>
                <template v-slot="{ row }">
                  <div class="table-charts-panel">
                    {{row.weight}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" min-width="100px">
                <template v-slot="{ row }">
                  <div class="table-view-detail">
                    <div class="text" @click="illnessWrongViewDetail(row)">查看详情<i class="el-icon-arrow-right el-icon--right"></i></div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <div class="title-card">
        <div class="card-header">
          <div class="bar"></div>
          <div class="title">班级PK</div>
        </div>
        <div class="card-content class-player-killing-content">
          <div class="card-empty-status"
            v-if=" !this.filterForm.class || !this.filterForm.chapter || 
              (classPlayerKillingData.self.length <= 0 && classPlayerKillingData.others.length <= 0)"
          >
          <!-- <div v-if="!filterForm.class || !filterForm.chapter" class="card-empty-status"> -->
            <img class="img-card-empty-status" src="../../assets/images/empty.png" draggable="false" alt="暂无数据～" />
            <div class="text">暂无数据～</div>
          </div>
          <template v-else>
            <div class="left-trapezoid"></div>
            <div class="content">
              <div class="left">
                <div class="title-tags">
                  <div class="tag tag-class-status">
                    <img src="../../assets/images/class-status.png" class="img-class-status" draggable="false" />
                    <div class="text">班级情况</div>
                  </div>
                  <div class="tag tag-theory-accuracy">
                    <img src="../../assets/images/theory-accuracy.png" class="img-theory-accuracy" draggable="false" />
                    <div class="text">理论题正确率</div>
                  </div>
                  <div class="tag tag-illness-accuracy">
                    <img src="../../assets/images/illness-accuracy.png" class="img-illness-accuracy" draggable="false" />
                    <div class="texts">
                      <div class="text">病例题正确率</div><div class="text text-bottom">(影像学/诊断)</div>
                    </div>
                  </div>
                </div>
                <template v-if="classPlayerKillingData.self.length > 0">
                  <div class="charts-panel" v-for="self in classPlayerKillingData.self" :key="self.id">
                    <div class="top-content">
                      <div class="title">{{self.gradeLevel + self.gradeName}}</div>
                      <div class="status-chart-panel">
                        <div class="describe">
                          <div class="number">{{self.totalNum}}人</div>
                          <div class="text">班级人数</div>
                        </div>
                        <div class="class-status-chart-container">
                          <div class="class-status-chart" :ref="`panel_self_${self.id}_classStatusPanelChart`"></div>
                          <div class="title">
                            <div class="number">{{self.finishRate}}%</div>
                            <div class="text">完成率</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="theory-chart-panel">
                      <div class="theory-accuracy-chart">
                        
                        <div class="bar-chart" :style="{width: `${self.questionRate}%`}">
                          <div class="data">{{self.questionRate}}%</div>
                        </div>
                      </div>
                    </div>
                    <div class="iDisplay-chart-panel">
                      <div class="iDisplay-accuracy-chart">
                        <div class="bar-chart" :style="{width: `${self.studyFindRate}%`}">
                          <div class="data">{{self.studyFindRate}}%</div>
                        </div>
                      </div>
                    </div>
                    <div class="iDiagnose-chart-panel">
                      <div class="iDiagnose-accuracy-chart">
                        <div class="bar-chart" :style="{width: `${self.studyRate}%`}">
                          <div class="data">{{self.studyRate}}%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div class="middle"><img src="../../assets/images/player-killing-VS.png" class="img-player-killing-vs" draggable="false" /></div>
              <div class="right">
                <template v-if="classPlayerKillingData.others.length > 0">
                  <div class="charts-panel" v-for="other in classPlayerKillingData.others" :key="other.id"
                     :class="classPlayerKillingData.others.length > 3 ? 'charts-panel-margin' : ''">
                    <div class="top-content">
                      <div class="title">{{other.gradeLevel + other.gradeName}}</div>
                      <div class="status-chart-panel">
                        <div class="describe">
                          <div class="number">{{other.totalNum}}人</div>
                          <div class="text">班级人数</div>
                        </div>
                        <div class="class-status-chart-container">
                          <div class="class-status-chart" :ref="`panel_other_${other.id}_classStatusPanelChart`"></div>
                          <div class="title">
                            <div class="number">{{other.finishRate}}%</div>
                            <div class="text">完成率</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="theory-chart-panel">
                      <div class="theory-accuracy-chart">
                        <!-- <div class="bar-chart" :style="{width: `${classPlayerKillingData.self && classPlayerKillingData.self.questionRate}`, minWidth: '29px'}"> -->
                        <div class="bar-chart" :style="{width: `${other.questionRate}%`}">
                          <div class="data">{{other.questionRate}}%</div>
                        </div>
                      </div>
                    </div>
                    <div class="iDisplay-chart-panel">
                      <div class="iDisplay-accuracy-chart">
                        <!-- <div class="bar-chart" :style="{width: `${classPlayerKillingData.self && classPlayerKillingData.self.studyFindRate}%`, minWidth: '25px'}"> -->
                        <div class="bar-chart" :style="{width: `${other.studyFindRate}%`}">
                          <div class="data">{{other.studyFindRate}}%</div>
                        </div>
                      </div>
                    </div>
                    <div class="iDiagnose-chart-panel">
                      <div class="iDiagnose-accuracy-chart">
                        <div class="bar-chart" :style="{width: `${other.studyRate}%`}">
                          <div class="data">{{other.studyRate}}%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="charts-panel" v-if="classPlayerKillingData.others.length == 2"></div>
                </template>
                <template v-else>
                  <div class="right-empty-status">
                    <img class="img-card-empty-status" src="../../assets/images/empty.png" />
                    <div class="text">暂无数据～</div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <template v-if="wrongDetailsVisible">
      <div class="anchor-overlay" @click="closeWrongDetails"></div>
      <div class="wrong-question-details">
        <div class="details-title">
          <div class="back-btn" @click="closeWrongDetails"><i class="el-icon-arrow-left"></i></div>
          <div class="text">错题详情</div>
        </div>
        <div class="details-scroll-content">
          <class-wrong-details
            :question-type="wrongDetailsType" :question-data-list="wrongDetailsData" :question-content-data="wrongDetailsContentData"
          ></class-wrong-details>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { comMethod } from '@/utils/index.js'
import { formatDate } from '@/utils/formatDate.js';
import { keyServer, classAnalysisServer, questionServer, caseServer } from '@/api/api';
import ClassWrongDetails from './ClassWrongDetails.vue'
export default {
  name: 'classAnalysis',
  components: { ClassWrongDetails },
  data () {
    return {
      filterForm: {
        major: '',
        class: '',
        chapter: ''
      },
      filterDataList: {
        major: [],
        class: [],
        chapter: []
      },
      studentRankData: {
        study: {
          name: 'studyProgress',
          title: '学习进度榜',
          class: 'study-progress-panel',
          data: [],
          dataKey: 'sectionRate',
          tooltip: '学习进度=已完成的必学小节/该章节的所有必学小节'
        },
        theory: {
          name: 'theoryProgress',
          title: '理论高手榜',
          class: 'theory-progress-panel',
          data: [],
          dataKey: 'questionRate',
          tooltip: '理论正确率=已提交的理论卷正确率叠加/已提交理论卷数'
        },
        illness: {
          name: 'studyProgress',
          title: '火眼金睛榜',
          class: 'golden-eye-panel',
          data: [],
          dataKey: 'studyRate',
          tooltip: '病例正确率=已提交的病例卷正确率叠加/已提交病例卷数'
        },
      },
      sectionStudyTableHeight: 300,
      sectionStudyTableData: {
        list: [],
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        searchFrom: {
          section: ''
        }
      },
      theoryWrongNavValue: 1,
      theoryWrongTableHeight: 300,
      theoryWrongTableData: [],
      illnessWrongTableData: [],
      theoryWrongNavOptions: [
        {name: 'single', title: '单选题', type: 1},
        {name: 'multiple', title: '多选题', type: 2},
        {name: 'judge', title: '判断题', type: 3},
        {name: 'fill', title: '填空题', type: 5},
        {name: 'sort', title: '排序题', type: 4}
      ],
      panelChartInstances: {},
      panelChartInstancesList:[],
      classPlayerKillingData: {
        self: [],
        others: []
      },
      wrongDetailsVisible: false,
      wrongDetailsType: 'single',
      wrongDetailsData: '',
      wrongDetailsContentData: '',
      timer: null,
      isFirstRender: '',
      sectionStudyNameSort: ''
    }
  },
  created () {
    this.getMajorName();
    this.sectionStudyTableHeight = comMethod.getTableHeight(590);
  },
  beforeDestroy() {
    this.disposeAllClassPanelCharts();
  },
  methods: {
    formatDate,
    async handleMajorChange() {
      this.filterForm.class ='';
      this.filterForm.chapter ='';
      await this.getClassName();
    },
    async handleClassChange() {
      if(this.filterForm.class) {
      this.filterForm.chapter ='';
        await this.getChapterName();
        if(this.filterForm.chapter) {
          await this.getAnalysisInformation();
        }
      }
    },
    async handleChapterChange() {
      if(this.filterForm.class && this.filterForm.chapter) {
        await this.getAnalysisInformation();
      }
    },
    async getMajorName () {
      try {
        const res = await keyServer.profession({
          dictionaryKey: 'profession'
        });
        const { code, data, message } = res;
        if (code === '0') {
          this.filterDataList.major = data;
          const targetItem = data.find(item => item.dictionaryName === "医学影像学专业");
          this.filterForm.major = targetItem ? targetItem.id : '';
          await this.getClassName();
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    async getClassName () {
      try {
        const res = await classAnalysisServer.queryGradeByProfessionId({
          professionId: this.filterForm.major
        });
        const { code, data, message } = res;
        if (code === '0') {
          this.filterDataList.class = data;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    async getChapterName () {
      try {
        const res = await classAnalysisServer.queryGradeDirectoryById({
          gradeId: this.filterForm.class
        });
        const { code, data, message } = res;
        if (code === '0') {
          this.filterDataList.chapter = data;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    async getAnalysisInformation() {
      await this.getStudentRankData();
      await this.getSectionStudyTableData(undefined, true);
      await this.getTheoryWrongTableData();
      await this.getIllnessWrongTableData();
      await this.getClassPlayerKillingData();
    },
    async getStudentRankData() {
      const backendParams = {
        gradeId: this.filterForm.class,
        directoryId: this.filterForm.chapter
      }
      try {
        const res = await classAnalysisServer.queryGradeStudentRankList({ ...backendParams });
        const { code, data, message } = res;
        if (code === '0') {
          const sectionList = data ? data.sectionList : [];
          const questionList = data ? data.questionList : [];
          const studyList = data ? data.studyList : [];
          this.studentRankData.study.data = sectionList;
          this.studentRankData.theory.data = questionList;
          this.studentRankData.illness.data = studyList;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    async getSectionStudyTableData(currentPage = 1, isFirstRender = false) {
      this.isFirstRender = isFirstRender;
      try {
        const params = {
          gradeId: this.filterForm.class,
          directoryId: this.filterForm.chapter,
          // gradeId: '87b72ffbc54a46938265b36570886e6f',
          // directoryId: '216',
          chapterName: this.sectionStudyTableData.searchFrom.section,
          page: currentPage,
          rows: this.sectionStudyTableData.pagination.pageSize,
        };
        let backendParams = {...params};
        if(this.sectionStudyNameSort) {
          backendParams = {
            ...params,
            sort: this.sectionStudyNameSort === 'ascending' ? 1 : 0
          }
        }
        const res = await classAnalysisServer.queryGradeChapterList({ ...backendParams });
        const { code, data, message } = res;
        if (code === '0') {
          const list = data ? data.records : [];
          const total = data ? data.total : 0;
          this.sectionStudyTableData.list = list;
          this.sectionStudyTableData.pagination.total = total;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    async getTheoryWrongTableData() {
      const backendParams = {
        gradeId: this.filterForm.class,
        directoryId: this.filterForm.chapter,
        // gradeId: 'f49be380876e44f0b0b17f95bf43278e',
        // directoryId: 2,
        questionType: this.theoryWrongNavValue
      }
      try {
        const res = await classAnalysisServer.queryQuestionList({ ...backendParams });
        const { code, data, message } = res;
        if (code === '0') {
          this.theoryWrongTableData = data;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    async getIllnessWrongTableData() {
      const backendParams = {
        gradeId: this.filterForm.class,
        directoryId: this.filterForm.chapter,
        // gradeId: '31e8bc8674f0420cbba9dcf49b9a31c1',
        // directoryId: 1
      }
      try {
        const res = await classAnalysisServer.queryStudyList({ ...backendParams });
        const { code, data, message } = res;
        if (code === '0') {
          this.illnessWrongTableData = data;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    async getClassPlayerKillingData() {
      const backendParams = {
        gradeId: this.filterForm.class,
        directoryId: this.filterForm.chapter,
        // gradeId: '9fd025eb13b74ddd89de38f8b125d2b2',
        // directoryId: 2
      }
      this.classPlayerKillingData.self = [];
      this.classPlayerKillingData.others = [];
      try {
        const res = await classAnalysisServer.queryGradeComparisonList({ ...backendParams });
        const { code, data, message } = res;
        if (code === '0') {
          const my = data && data.my ? [data.my] : [];
          const other = data ? data.other : [];
          this.classPlayerKillingData.self = my;
          this.classPlayerKillingData.others = other;
          this.setPanelChartInstancesList();
          this.initAllClassPanelCharts();
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    async getTheoryWrongDetailsData(row) {
      const backendParams = {
        gradeId: this.filterForm.class,
        questionId: row.id
        // gradeId: '74726ecc68774c3a8ea91432432b30a1',
        // questionId: 'efe437bb8c504ea394b24bdf2746df9b '
      }
      try {
        const res = await classAnalysisServer.queryQuestionDetail({ ...backendParams });
        const { code, data, message } = res;
        if (code === '0') {
          this.wrongDetailsData = data;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    async getIllnessWrongDetailsData(row) {
      const backendParams = {
        gradeId: this.filterForm.class,
        studyId: row.id
        // gradeId: '803d7ea3a1b0424bb1173404539420ef',
        // studyId: '95e9ce0d4ca64853889d19f43e6332bb'
      }
      try {
        const res = await classAnalysisServer.queryStudyDetail({ ...backendParams });
        const { code, data, message } = res;
        if (code === '0') {
          this.wrongDetailsData = data;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    async getTheoryWrongDetailsContentData(row) {
      const backendParams = {
        id: row.id
        // id: 'efe437bb8c504ea394b24bdf2746df9b'
      }
      try {
        const res = await questionServer.questionDetail({ ...backendParams });
        const { code, data, message } = res;
        if (code === '0') {
          this.wrongDetailsContentData = data;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    async getIllnessWrongDetailsContentData(row) {
      const backendParams = {
        studyId: row.id
      }
      try {
        const res = await caseServer.caseDetail({ ...backendParams });
        const { code, data, message } = res;
        if (code === '0') {
          this.wrongDetailsContentData = data;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },

    async theoryWrongNavClick(item) {
      this.theoryWrongNavValue = item.type;
      await this.getTheoryWrongTableData();
    },
    async theoryWrongViewDetail(row) {
      await this.getTheoryWrongDetailsData(row);
      await this.getTheoryWrongDetailsContentData(row);
      const navItem = this.theoryWrongNavOptions.find(item => item.type === this.theoryWrongNavValue)
      this.wrongDetailsType = navItem.name;
      this.wrongDetailsVisible = true;
    },
    async illnessWrongViewDetail(row) {
      await this.getIllnessWrongDetailsData(row);
      await this.getIllnessWrongDetailsContentData(row);
      this.wrongDetailsType = 'illness';
      this.wrongDetailsVisible = true;
    },
    closeWrongDetails() {
      this.wrongDetailsVisible = false;
    },
    
    setPanelChartInstancesList() {
      this.panelChartInstancesList = [];
      if(this.classPlayerKillingData.others.length <= 0) return;
      this.classPlayerKillingData.others.forEach(other => {
        this.panelChartInstancesList.push(`panel_other_${other.id}_classStatusPanelChart`);
      })
    },

    initAllClassPanelCharts() {
      this.$nextTick(() => {
        this.timer = setTimeout(() => {
          if(this.classPlayerKillingData.self.length > 0) {
            const selfRef = `panel_self_${this.classPlayerKillingData.self[0].id}_classStatusPanelChart`;
            this.initClassPanelChart(selfRef, this.classPlayerKillingData.self[0].finishRate);
          }
          if(this.panelChartInstancesList.length <= 0) return;
          this.panelChartInstancesList.forEach((item, index) => {
            this.initClassPanelChart(item, this.classPlayerKillingData.others[index].finishRate);
          });
        }, 100);
      })
    },
    initClassPanelChart(refName, data) {
      const chartRef = this.$refs[refName][0];
      if (!chartRef) return;
      if (this.panelChartInstances && this.panelChartInstances[refName]) {
        this.panelChartInstances[refName].dispose();
      }
      if (!this.panelChartInstances) this.panelChartInstances = {};
      this.panelChartInstances[refName] = echarts.init(chartRef);
      this.panelChartInstances[refName].setOption(this.getPanelPieOption(data));
    },
    getPanelPieOption(value) {
      const option = {
        series: [
          {
            name: 'classStatusPanelChart',
            type: 'pie',
            itemStyle: {
              borderRadius: 100,
            },
            radius: ['60%', '100%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: false
            },
            emphasis: {
              scale: false,
              scaleSize: 0,
              label: {
                show: false
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: value,
                name: '已完成',
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [
                    {offset: 0, color: '#8BC6EC'},
                    {offset: 1, color: '#3073FB'}
                  ])
                }
              },
              {
                value: 100 - value,
                name: '未完成', 
                itemStyle: {
                  color: 'transparent'
                }
              }
            ]
          }
        ]
      };
      return option;
    },
    disposeAllClassPanelCharts() {
      if(this.timer) clearTimeout(this.timer);
      if (this.panelChartInstances) {
        Object.keys(this.panelChartInstances).forEach(chartName => {
          if (this.panelChartInstances[chartName]) {
            this.panelChartInstances[chartName].dispose();
          }
        });
      }
    },

    sectionStudySearch (currentPage = 1) {
      this.getSectionStudyTableData(currentPage);
    },
    // pageSize 改变时会触发
    handleSizeChange (val) {
      this.sectionStudyTableData.pagination.pageSize = val;
      this.sectionStudyTableData.pagination.currentPage = 1;
      this.sectionStudySearch();
    },
    // currentPage 改变时会触发
    handleCurrentChange (currentPage) {
      this.sectionStudyTableData.pagination.currentPage = currentPage
      this.sectionStudySearch(currentPage);
    },
    handleSortChange(params) {
      this.sectionStudyNameSort = params.order;
      this.sectionStudyTableData.pagination.currentPage = 1;
      this.sectionStudySearch();
    }
  }
}
</script>
<style lang="scss">
.el-tooltip__popper.sectionRate {
  color: rgba(54, 110, 244, 0.88);
  border-radius: 4px;
  font-size: 12px;
  background: #F2F6FD;
  border: none;
  box-shadow: -1px 0px 11px 0px rgba(0, 82, 217, 0.24);
  padding: 16px 8px;
  .popper__arrow {
    border-width: 0px;
    background: #F2F6FD;
    border-color: #F2F6FD;
  }
}
.el-tooltip__popper.questionRate {
  color: #31BD65;
  border-radius: 4px;
  font-size: 12px;
  background: #F5FBF7;
  border: none;
  box-shadow: -1px 0px 11px 0px rgba(49, 189, 101, 0.24);
  padding: 16px 8px;
  .popper__arrow {
    border-width: 0px;
    background: #F5FBF7;
    border-color: #F5FBF7;
  }
}
.el-tooltip__popper.studyRate {
  color: #34B5B6;
  border-radius: 4px;
  font-size: 12px;
  background: #F7FCFC;
  border: none;
  box-shadow: -1px 0px 11px 0px rgba(68, 188, 190, 0.24);
  padding: 16px 8px;
  .popper__arrow {
    border-width: 0px;
    background: #F7FCFC;
    border-color: #F7FCFC;
  }
}
</style>
<style lang="scss" scoped>
.class-analysis {
  width: 100%;
  overflow-y: auto;
  border-radius: 16px;
  padding: 24px 4px;
  background: rgba(255, 255, 255, 0.8);
  position: relative;
  .analysis-filter {
    margin: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      /deep/ .el-form-item {
        margin-bottom: 0px;
      }
      /deep/ .el-select {
        .el-input__inner {
          width: 196px;
          height: 32px;
          border-radius: 4px;
          color: #4F6389;
          font-size: 14px;
          border: 1px solid #D0DFFB;
          font-family: PingFang SC;
        }
      }
    }
    .right {
      font-size: 14px;
      font-weight: normal;
      color: #4F6389;
      span {
        font-family: PingFang SC;
      }
    }
  }
  .scroll-content {
    height: calc(100vh - 158px);
    overflow-y: auto;
    padding: 0 20px;
    .title-card {
      .card-header {
        margin-top: 6px;
        height: 42px;
        display: flex;
        align-items: center;
        .bar {
          width: 4px;
          height: 16px;
          border-radius: 40px;
          background: #0052D9;
          margin-right: 8px;
        }
        .title {
          font-family: AlimamaShuHeiTi;
          font-size: 18px;
          font-weight: bold;
          color: #000000;
        }
      }
      .card-empty-status {
        height: 306px;
        .img-card-empty-status {
          width: 196px;
          height: 154px;
          margin: 0 auto;
          margin-top: 64px;
        }
        .text {
          text-align: center;
          font-size: 16px;
          font-weight: normal;
          font-family: PingFang SC;
          color: #8DA0C2;
        }
      }
      .card-content {
        background: #FFFFFF;
        border-radius: 16px;
      }
      /deep/ .el-table .el-table__cell {
        padding: 8px 0px;
        .cell {
          font-family: 'PingFang SC';
          font-size: 16px;
        }
      }
      /deep/ .el-table th.el-table__cell {
        padding: 6px 0px;
      }
    }
    .student-rank-content {
      padding: 24px 16px;
      .rank-content {
        display: flex;
        justify-content: space-between;
        .rank-panel {
          position: relative;
          width: 32%;
          min-width: 300px;
          border-radius: 16px;
          padding: 0 26px 16px 16px;
          .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 100px;
            .text {
              font-family: AlimamaShuHeiTi;
              font-size: 32px;
              font-weight: bold;
              text-align: left;
              .icon {
                font-size: 16px;
                vertical-align: top;
              }
            }
            [class^="img-medal"], [class*=" img-medal"] {
              height: 100%;
              width: auto;
            }
          }
          .ranks {
            display: flex;
            justify-content: center;
            align-content: space-between;
            flex-wrap: wrap;
            height: 240px;
            width: 100%;
            border-radius: 16px;
            background: #FFFFFF;
            padding: 16px 24px;
            .rank {
              width: 100%;
              display: flex;
              justify-content: space-between;
              font-size: 16px;
              font-weight: normal;
              height: auto;
              .img-rank-trophy {
                // width: 30px;
                width: 36px;
                height: 36px;
                vertical-align: middle;
                margin-top: -2px;
              }
              .name {
                font-family: PingFang SC;
                color: #3D3D3D;
              }
              .progress {
                font-family: PingFang SC;
              }
              .rank-number {
                font-family: PingFang SC;
                font-size: 18px;
                font-weight: 800;
              }
            }
            .omit {
              text-align: center;
              font-size: 20px;
              font-family: PingFang SC;
            }
            .rank-placeholder {
              width: 100%;
              height: 30px;
            }
          }
        }
        .study-progress-panel {
          background: linear-gradient(180deg, rgba(238, 243, 255, 0.8) 0%, rgba(238, 243, 255, 0.352) 100%);
          .title {
            .text {
              background: linear-gradient(256deg, #495BD0 12%, #526BD4 53%, #7FB9E8 95%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
            }
          }
          .ranks {
            .rank {
              .progress {
                color: #003CAB;
              }
              .rank-number {
                background: linear-gradient(180deg, #9CB9FF 34%, #366EF4 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
              }
            }
            .omit {
              color: #C4DAFD;
            }
          }
        }
        .theory-progress-panel {
          background: linear-gradient(180deg, rgba(238, 252, 240, 0.8) 0%, rgba(238, 245, 241, 0.56) 100%);
          .title {
            .text {
              background: linear-gradient(260deg, #32BE65 17%, #59C567 74%, #7BE568 94%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
            }
          }
          .ranks {
            .rank {
              .progress {
                color: #358C05;
              }
              .rank-number {
                background: linear-gradient(180deg, #8FE184 34%, #3ED457 97%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
              }
            }
            .omit {
              color: #C7E1D0;
            }
          }
        }
        .golden-eye-panel {
          background: linear-gradient(180deg, rgba(226, 255, 253, 0.8) 0%, rgba(241, 253, 252, 0.8) 100%);
          .title {
            .text {
              background: linear-gradient(263deg, #2AB0B0 12%, #51C1C5 76%, rgba(103, 178, 219, 0.6) 98%, rgba(103, 219, 115, 0.79) 98%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
            }
          }
          .ranks {
            .rank {
              .progress {
                color: #08979C;
              }
              .rank-number {
                background: linear-gradient(180deg, #77EEEE 34%, #36ABF4 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                // text-fill-color: transparent;
              }
            }
            .omit {
              color: #C9E5E1;
            }
          }
        }
      }
    }
    .section-study-detail-content {
      padding-bottom: 6px;
      .search-panel {
        text-align: left;
        padding: 16px;
        .search-btn {
          display: inline-block;
          width: 60px;
          height: 32px;
          border-radius: 4px;
          cursor: pointer;
          border: 1px solid #D0DFFB;
          color: #0052D9;
          font-family: PingFang SC;
          font-size: 14px;
          line-height: 32px;
          margin-left: 2px;
          text-align: center;
        }
        /deep/ .el-form-item {
          margin-bottom: 0px;
        }
        /deep/ .el-input__inner {
          font-family: PingFang SC;
          width: 328px;
          height: 32px;
          border: 1px solid #D0DFFB;
          // color: #AAB4D2;
        }
        /deep/ .el-select {
          .el-input__inner {
            width: 160px;
            border-radius: 4px;
            color: #4F6389;
            font-family: PingFang SC;
          }
        }
      }
      .section-study-table {
        padding: 0 16px;
        .table-section-name {
          display: flex;
          align-items: center;
          .name {
            font-family: PingFang SC;
          }
          .tag {
            width: 30px;
            height: 18px;
            border-radius: 60px;
            line-height: 14px;
            box-sizing: border-box;
            font-size: 12px;
            font-weight: 500;
            text-align: center;
            margin-left: 16px;
            margin-top: 4px;
            flex: none;
          }
          .necessary {
            background: #FFEED6;
            border: 1px solid #FFA424;
            color: #FFA424;
          }
          .choice {
            background: #E1EAFF;
            border: 1px solid #7AA3FF;
            color: #7AA3FF;
          }
        }
        .table-charts-panel {
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          .table-pie-chart {
            width: 26px;
            height: 26px !important;
            position: relative;
            .pie-chart {
              width: 26px;
              height: 26px;
              border-radius: 50%;
              background: conic-gradient(#366EF4 var(--progress), #c5d2fa 0deg);
              position: relative;
              &::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 50%;
                height: 50%;
                border-radius: 50%;
                // background-color: #f5f8fd;
                background-color: #ffffff;
              }
            }
          }
          .table-pie-data {
            font-size: 16px;
            color: #003CAB;
            margin-left: 8px;
            min-width: 60px;
            // text-align: right;
          }
          .table-bar-chart {
            width: 80px;
            height: 8px;
            margin-left: 30px;
            border-radius: 4.5px;
            background: #daead1;
            .bar-chart {
              height: 100%;
              border-radius: 4.5px;
              background: #439613;
            }
          }
          .table-bar-data {
            font-size: 16px;
            color: #358C05;
            margin: 0 8px;
            width: 60px;
          }
        }
      }
      .pagination-panel {
        margin: 12px 0;
        text-align: right;
        /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
          background: #2B5EEF;
        }
        /deep/ .el-pagination.is-background .btn-next, /deep/ .el-pagination.is-background .btn-prev, /deep/ .el-pagination.is-background .el-pager li {
          border-radius: 8px;
        }
        /deep/ .el-pagination__jump {
          font-family: PingFang SC;
          font-size: 14px;
          margin-left: 14px;
        }
        /deep/ .el-pagination__total {
          font-family: PingFang SC;
          font-size: 14px;
        }
        /deep/ .el-pagination__sizes .el-input .el-input__inner {
          font-family: PingFang SC;
        }
      }
    }
    .chapter-theory-wrong-content {
      background: transparent !important;
      margin-top: 20px;
      .nav-bars {
        height: 48px;
        background: rgba(255, 255, 255, 0.4);
        box-shadow: inset -4px 4px 24px 0px #FFFFFF;
        display: flex;
        align-items: flex-end;
        border-radius: 16px 16px 0px 0px;
        .nav {
          width: 96px;
          height: 48px;
          text-align: center;
          line-height: 48px;
          font-family: PingFang SC;
          font-size: 16px;
          color: #7E94BE;
          cursor: pointer;
          transition: all 0.3s ease-in-out;
          user-select: none;
        }
        .active-nav {
          width: 112px;
          height: 64px;
          border-radius: 16px 16px 0px 0px;
          background: #FFFFFF;
          box-shadow: 0px -8px 12px 0px rgba(115, 169, 255, 0.3);
          text-align: center;
          line-height: 64px;
          font-family: PingFang SC;
          color: #4F6389;
          font-size: 16px;
          transition: all 0.3s ease-in-out;
        }
      }
      .card-empty-status {
        background: #FFFFFF;
        border-radius: 0 0 16px 16px;
      }
      .theory-wrong-table {
        padding: 16px;
        background: #FFFFFF;
        border-radius: 0px 0px 16px 16px;
        .table-charts-panel {
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          .table-bar-chart {
            width: 136px;
            height: 10px;
            margin-left: 30px;
            height: 8px;
            border-radius: 4.5px;
            background: #fce3e8;
            .bar-chart {
              height: 100%;
              border-radius: 4.5px;
              background: #FC708A;
            }
          }
          .table-bar-data {
            font-size: 16px;
            color: #FC708A;
            margin: 0 8px;
            width: 60px;
          }
        }
        .table-view-detail {
          font-size: 14px;
          color: #0052D9;
          cursor: pointer;
          .text {
            font-family: PingFang SC;
            letter-spacing: 0em;
          }
        }
        .header-wrong-weight {
          font-family: PingFang SC;
          font-size: 16px;
          font-weight: 600;
          color: #4F6389;
          display: flex;
          align-items: center;
          justify-content: center;
          .img-view-details {
            height: 16px;
            width: 16px;
            margin-left: 2px;
          }
        }
      }
    }
    .chapter-illness-wrong-content {
      .illness-wrong-table {
        padding: 16px;
        background: #FFFFFF;
        border-radius: 0px 0px 16px 16px;
        .table-charts-panel {
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          .table-bar-chart {
            width: 136px;
            height: 10px;
            margin-left: 30px;
            height: 8px;
            border-radius: 4.5px;
            background: #fce3e8;
            .bar-chart {
              height: 100%;
              border-radius: 4.5px;
              background: #FC708A;
            }
          }
          .table-bar-data {
            font-size: 16px;
            color: #FC708A;
            margin: 0 8px;
            width: 60px;
          }
        }
        .table-view-detail {
          font-size: 14px;
          color: #0052D9;
          cursor: pointer;
          .text {
            font-family: PingFang SC;
            letter-spacing: 0em;
          }
        }
        .header-wrong-weight {
          font-family: PingFang SC;
          font-size: 16px;
          font-weight: 600;
          color: #4F6389;
          display: flex;
          align-items: center;
          justify-content: center;
          .img-view-details {
            height: 16px;
            width: 16px;
            margin-left: 2px;
          }
        }
      }
    }
    .class-player-killing-content {
      .card-empty-status {
        background: #FFFFFF;
        border-radius: 16px;
      }
      position: relative;
      width: 100%;
      height: 318px;
      background: linear-gradient(180deg, rgba(234, 255, 253, 0.7) 0%, rgba(223, 255, 252, 0.3) 100%, rgba(234, 255, 253, 0) 100%) !important;
      min-width: max-content;
      .left-trapezoid{
        width: 40%;
        height: 410px;
        min-width: 568px;
        background: linear-gradient(180deg, #D5EAFF 0%, rgba(235, 243, 250, 0.7) 100%);
        border-radius: 16px;
        transform: perspective(100px) rotateX(-4deg);
        transform-origin: top left;
      }
      .content {
        width: calc(100% - 32px);
        height: calc(100% - 32px);
        z-index: 2;
        position: absolute;
        top: 16px;
        left: 16px;
        display: flex;
        .charts-panel {
          width: 225px;
          .top-content {
            height: 150px;
            display: flex;
            align-content: space-between;
            justify-content: center;
            flex-wrap: wrap;
            width: 100%;
            .title {
              font-family: AlimamaShuHeiTi;
              font-size: 18px;
              font-weight: bold;
              text-align: center;
              width: 100%;
            }
            .status-chart-panel {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              height: 100px;
              .describe {
                margin: 0 24px;
                .number {
                  font-family: PingFang SC;
                  font-size: 16px;
                  font-weight: 600;
                  color: #4F6389;
                }
                .text {
                  font-family: PingFang SC;
                  font-size: 16px;
                  font-weight: normal;
                  color: #4F6389;
                }
              }
              .class-status-chart-container {
                width: 100px;
                height: 100px;
                position: relative;
                .title {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  .number {
                    font-family: PingFang SC;
                    font-size: 15px;
                    font-weight: 600;
                    color: #4F6389;
                  }
                  .text {
                  font-family: PingFang SC;
                  font-size: 15px;
                  font-weight: normal;
                  color: #4F6389;
                  }
                }
              }
              .class-status-chart {
                width: 100px;
                height: 100px;
                &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 100px;
                height: 100px;
                border-radius: 50%;
                z-index: -2;
                }
                &::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 60px;
                height: 60px;
                // deeefe
                border-radius: 50%;
                z-index: -1;
                }
              }
            }
          }
          .theory-chart-panel {
            margin-top: 26px;
            width: 224px;
            height: 21px;
            border-radius: 80px;
            position: relative;
            background: linear-gradient(to left, #e5f1fc 0%, #e6f1fc 100%);
            padding: 2px 0;
            &::before {
              content: '';
              position: absolute;
              top: -1px;
              left: -1px;
              right: -1px;
              bottom: -1px;
              background: linear-gradient(270deg, #86E23F 0%, rgba(134, 226, 63, 0) 100%);
              border-radius: 80px;
              z-index: -2;
            }
            .theory-accuracy-chart {
              width: 222px;
              height: 17px;
              border-radius: 80px;
              background: transparent;
              .bar-chart {
                height: 100%;
                border-radius: 80px;
                background: linear-gradient(270deg, #86E23F 0%, #A9FA6A 100%);
                text-align: right;
                .data {
                  margin: 0 2px;
                  font-family: PingFang SC;
                  font-size: 12px;
                  font-weight: 500;
                  color: #FFFFFF;
                }
              }
            }
          }
          .iDisplay-chart-panel {
            margin-top: 33px;
            width: 224px;
            height: 18px;
            border-radius: 80px;
            position: relative;
            background: linear-gradient(to left, #e5f1fc 0%, #e6f1fc 100%);
            padding: 2px 0;
            &::before {
              content: '';
              position: absolute;
              top: -1px;
              left: -1px;
              right: -1px;
              bottom: -1px;
              background: linear-gradient(270deg, #366EF4 0%, rgba(54, 110, 244, 0) 100%);
              border-radius: 80px;
              z-index: -2;
            }
            .iDisplay-accuracy-chart {
              width: 222px;
              height: 14px;
              border-radius: 80px;
              background: transparent;
              .bar-chart {
                height: 100%;
                border-radius: 80px;
                background: linear-gradient(270deg, #366EF4 0%, #92DCF9 99%);
                text-align: right;
                .data {
                  margin: 0 2px;
                  font-family: PingFang SC;
                  font-size: 10px;
                  font-weight: 500;
                  color: #FFFFFF;
                }
              }
            }
          }
          .iDiagnose-chart-panel {
            margin-top: 9px;
            width: 224px;
            height: 18px;
            border-radius: 80px;
            position: relative;
            background: linear-gradient(to left, #e5f1fc 0%, #e6f1fc 100%);
            padding: 2px 0;
            &::before {
              content: '';
              position: absolute;
              top: -1px;
              left: -1px;
              right: -1px;
              bottom: -1px;
              background: linear-gradient(270deg, #00D6C5 0%, rgba(0, 214, 197, 0) 100%);
              border-radius: 80px;
              z-index: -2;
            }
            .iDiagnose-accuracy-chart {
              width: 222px;
              height: 14px;
              border-radius: 80px;
              background: transparent;
              .bar-chart {
                height: 100%;
                border-radius: 80px;
                background: linear-gradient(270deg, #00D6C5 0%, #92F9DC 99%);
                text-align: right;
                .data {
                  margin: 0 2px;
                  font-family: PingFang SC;
                  font-size: 10px;
                  font-weight: 500;
                  color: #FFFFFF;
                }
              }
            }
          }
        }
        .left {
          display: flex;
          justify-content: space-between;
          width: 28%;
          min-width: 388px;
          .title-tags {
            width: 121px;
            margin-left: 13px;
            .tag {
              padding: 7px;
              display: flex;
              align-items: center;
              border-radius: 4px;
              background: linear-gradient(270deg, rgba(255, 255, 255, 0) 11%, rgba(255, 255, 255, 0.5) 100%);
              box-shadow: 0px 5px 3px 0px rgba(130, 169, 231, 0.03),inset 4px 0px 10px 0px rgba(255, 255, 255, 0.37);
              [class^="img"] {
                height: 14px;
                width: 14px;
                margin-right: 4px;
              }
              .text {
                font-family: PingFang SC;
                font-size: 14px;
                font-weight: 500;
                color: #7891B4;
              }
              .text-bottom {
                margin-top: 3px;
              }
            }
            .tag-class-status {
              margin-top: 83px;
            }
            .tag-theory-accuracy {
              margin-top: 60px;
            }
            .tag-illness-accuracy {
              margin-top: 24px;
              .img-illness-accuracy {
                height: 16px;
                width: 16px;
                margin-right: 2px;
                margin-bottom: 17px;
              }
            }
          }
          .charts-panel {
            .title {
              color: #5B92ED;
            }
            .class-status-chart {
              &::before {
                background-color: rgba(138, 172, 252, 0.3);
              }
              &::after {
                background-color: #deeefe;
              }
            }
          }
        }
        .middle {
          width: 16%;
          min-width: 184px;
          display: flex;
          align-items: center;
          justify-content: center;
          .img-player-killing-vs {
            height: 90px;
            width: 164px;
          }
        }
        .right {
          width: 56%;
          display: flex;
          justify-content: space-between;
          // overflow: hidden;
          overflow-x: auto;
          // height: 100%;
          .charts-panel {
            margin: 0 5px;
            .title {
              color: #51C1C5;
            }
            .class-status-chart {
              &::before {
                // background-color: rgba(209, 228, 252, 0.3);
                background-color: #d1e4fc;
              }
              &::after {
                background-color: #ecfafd;
              }
            }
            .theory-chart-panel {
              background: linear-gradient(to left, #EAFFFD 0%, #EAFFFD 100%);
            }
            .iDisplay-chart-panel {
              background: linear-gradient(to left, #EAFFFD 0%, #EAFFFD 100%);
            }
            .iDiagnose-chart-panel {
              background: linear-gradient(to left, #EAFFFD 0%, #EAFFFD 100%);
            }
          }
          .charts-panel-margin {
            margin-right: 20px;
          }
        }
        .right-empty-status {
          margin:  0 auto;
          .img-card-empty-status {
            width: 196px;
            height: 154px;
            margin: 0 auto;
            margin-top: 64px;
          }
          .text {
            text-align: center;
            font-size: 16px;
            font-weight: normal;
            font-family: PingFang SC;
            color: #8DA0C2;
          }
        }
      }
    }
  }
  .anchor-overlay {
    position: fixed;
    top: 0px;
    left: 0;
    height: 100vh;
    width: 100%;
    // background: transparent;
    background: rgba(100, 100, 100, 0.1);
    z-index: 1002;
  }
  // .transtion-details-enter-active, .transtion-details-leave-active {
  //   transition: all 0.5s ease;
  // }
  // .transtion-details-enter, .transtion-details-leave-to {
  //   opacity: 0;
  // }
  .wrong-question-details {
    position: fixed;
    top: 0px;
    right: 0;
    height: 100vh;
    width: 600px;
    background: #FFFFFF;
    z-index: 1003;
    // transition: all 1s ease-in-out;
    .details-title{
      width: 100%;
      height: 58px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 16px 260px 16px 24px;
      box-shadow: inset 0px -1px 0px 0px #F0F0F0;
      .back-btn {
        color: #8DA0C2;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
      }
      .text {
        font-size: 20px;
        font-weight: bold;
        color: #4F6389;
        font-family: AlimamaShuHeiTi;
      }
    }
    .details-scroll-content {
      // padding: 16px 24px;
      width: 100%;
      height: calc(100% - 58px);
      overflow-y: auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/teachAnalysis/classAnalysis.vue